import PcModelComponentImageModal from 'containers/PcModel/PcModelComponentImageModal';
import PropTypes from 'prop-types';
import { useState } from 'react';
import PcModelOptionImage from '../PcModelOptionImage';
import styles from './styles';

const PcModelOptionImageWithModal = ({
  src,
  alt,
  width,
  height,
  groupTitle,
  options,
  currentOption,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updatedOptions, setUpdatedOptions] = useState(options);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const variantIds = options.map((option) => option.variant_id);

  const fetchData = async () => {
    try {
      if (!isDataLoaded) {
        const variantIdsString = variantIds.join(',');

        const response = await fetch(`/api/shopify/product/variant?variantIds=${variantIdsString}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        const productIdsString = Object.values(data).map((variant) => variant.product.id).join(',');
        
        const detailsResponse = await fetch(`/api/shopify/product/details?productIds=${productIdsString}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 's-maxage=10800', // Cache for 3 hours
          },
        });

        if (!detailsResponse.ok) {
          throw new Error(`HTTP error! Status: ${detailsResponse.status}`);
        }

        const detailsData = await detailsResponse.json();
        const detailsDataArray = Object.values(detailsData)

        const newOptions = options.map((option, index) => {
          return {
            ...option,
            description: detailsDataArray[index].description
          }
        });

        setUpdatedOptions(newOptions);
        setIsDataLoaded(true);
        return;
      }
    } catch (error) {
      console.error('Error fetching products:', error.message);
    }
  };

  return (
    <>
      <div className="trigger" onClick={() => {
        fetchData();
        setIsModalOpen(true);
      }}>
        <PcModelOptionImage src={src} alt={alt} width={width} height={height} />
      </div>

      <div className='more-info-container' onClick={() => {
        fetchData();
        setIsModalOpen(true);
      }}>
        <a className='more-info'>MORE INFO</a>
      </div>

      <PcModelComponentImageModal
        isOpen={isModalOpen}
        isDataLoaded={isDataLoaded}
        onClose={() => setIsModalOpen(false)}
        groupTitle={groupTitle}
        options={updatedOptions}
        currentOption={currentOption}
      />
      <style jsx>{styles}</style>
    </>
  );
};

PcModelOptionImageWithModal.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  groupInfo: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  currentOption: PropTypes.object.isRequired,
};

PcModelOptionImageWithModal.defaultProps = {
  src: 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/image-placeholder.png?v=1714058007',
  alt: 'Component Image',
  height: 300,
  width: 300
};

export default PcModelOptionImageWithModal;
